import { render } from "./LoadingComponent.vue?vue&type=template&id=1adbc26b&scoped=true"
const script = {}

import "./LoadingComponent.vue?vue&type=style&index=0&id=1adbc26b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1adbc26b"]])

export default __exports__